(function() {
  function initCartFooterCustom() {
    const footer = document.querySelector('[data-cart-footer]');
    if (!footer) return;

    const cb = document.getElementById('cart-agree-terms');
    const ov = document.getElementById('cart-overlay');
    const wi = document.getElementById('cart-buttons-inner');
    const er = footer.querySelector('.cart-err-msg');

    const cartIsEmpty = footer.classList.contains('is-empty');

    function setConsentErrorState(isError) {
      if (cb) {
        cb.setAttribute('aria-invalid', isError ? 'true' : 'false');
      }
    }

    function showCartConsentError(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (er) {
        er.style.display = 'block';
      }

      setConsentErrorState(true);

      if (cb) {
        cb.style.outline = '2px solid #ef3a12';
        cb.style.outlineOffset = '2px';

        if (typeof cb.focus === 'function') {
          cb.focus({ preventScroll: true });
        }

        setTimeout(function() {
          cb.style.outline = 'none';
        }, 1000);
      }
    }

    function getCartPaymentFocusables() {
      if (!wi) return [];

      return Array.prototype.slice.call(
        wi.querySelectorAll('a[href], area[href], button, input, select, textarea, iframe, [tabindex]')
      );
    }

    function lockCartPaymentFocusables() {
      if (!wi) return;

      getCartPaymentFocusables().forEach(function(el) {
        if (el.dataset.cartOriginalTabindex === undefined) {
          el.dataset.cartOriginalTabindex = el.hasAttribute('tabindex')
            ? el.getAttribute('tabindex')
            : '';
        }

        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');

        if (el.matches('button, input, select, textarea')) {
          if (el.dataset.cartOriginalDisabled === undefined) {
            el.dataset.cartOriginalDisabled = el.disabled ? 'true' : 'false';
          }

          el.disabled = true;
        }
      });
    }

    function unlockCartPaymentFocusables() {
      if (!wi) return;

      getCartPaymentFocusables().forEach(function(el) {
        const originalTabindex = el.dataset.cartOriginalTabindex;

        if (originalTabindex === '') {
          el.removeAttribute('tabindex');
        } else if (originalTabindex !== undefined) {
          el.setAttribute('tabindex', originalTabindex);
        }

        el.removeAttribute('aria-hidden');

        if (el.matches('button, input, select, textarea')) {
          if (el.id === 'checkout' && cartIsEmpty) {
            el.disabled = true;
          } else {
            el.disabled = false;
          }
        }
      });
    }

    function setCartPaymentLockState() {
      if (!ov || !cb || !wi) return;

      if (cb.checked) {
        ov.classList.add('hidden');
        ov.setAttribute('aria-hidden', 'true');
        ov.setAttribute('tabindex', '-1');

        wi.classList.add('active');
        wi.removeAttribute('inert');
        wi.setAttribute('aria-disabled', 'false');
        wi.setAttribute('aria-hidden', 'false');

        unlockCartPaymentFocusables();

        if (er) {
          er.style.display = 'none';
        }

        setConsentErrorState(false);
      } else {
        ov.classList.remove('hidden');
        ov.setAttribute('aria-hidden', 'false');
        ov.setAttribute('tabindex', '0');

        wi.classList.remove('active');
        wi.setAttribute('inert', '');
        wi.setAttribute('aria-disabled', 'true');
        wi.setAttribute('aria-hidden', 'true');

        lockCartPaymentFocusables();
      }
    }

    if (ov && cb && wi && er && ov.dataset.cartLockReady !== 'true') {
      ov.dataset.cartLockReady = 'true';

      setCartPaymentLockState();

      ov.addEventListener('click', showCartConsentError);

      ov.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        showCartConsentError(e);
      });

      wi.addEventListener('click', function(e) {
        if (cb.checked) return;
        showCartConsentError(e);
      }, true);

      wi.addEventListener('keydown', function(e) {
        if (cb.checked) return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        showCartConsentError(e);
      }, true);

      cb.addEventListener('change', setCartPaymentLockState);

      const cartForm = document.getElementById('cart');

      if (cartForm && cartForm.dataset.cartConsentGuardReady !== 'true') {
        cartForm.dataset.cartConsentGuardReady = 'true';

        cartForm.addEventListener('submit', function(e) {
          const submitter = e.submitter || document.activeElement;
          const isCheckoutSubmit = submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout';

          if (!cb.checked && isCheckoutSubmit) {
            showCartConsentError(e);
          }
        }, true);
      }

      if (typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(function() {
          setCartPaymentLockState();
        });

        observer.observe(wi, {
          childList: true,
          subtree: true
        });
      }
    }

    function getPopupTriggers() {
      return document.querySelectorAll('[data-cart-footer] [data-cart-info-popup]');
    }

    function isCartPopupTapMode() {
      return window.matchMedia('(max-width: 768px), (hover: none), (pointer: coarse)').matches;
    }

    function setTriggerExpanded(trigger, expanded) {
      if (!trigger) return;

      trigger.querySelectorAll('[aria-expanded]').forEach(function(control) {
        control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function closeCartInfoPopups(exceptTrigger) {
      getPopupTriggers().forEach(function(trigger) {
        if (trigger !== exceptTrigger) {
          trigger.classList.remove('is-info-active');
          trigger.classList.remove('is-magnifier-visible');
          setTriggerExpanded(trigger, false);

          const popup = trigger.querySelector('.cart-info-popup');
          if (popup) {
            popup.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }

    function showCartMagnifier(trigger) {
      closeCartInfoPopups(trigger);
      trigger.classList.remove('is-info-active');
      trigger.classList.add('is-magnifier-visible');
      setTriggerExpanded(trigger, false);

      const popup = trigger.querySelector('.cart-info-popup');
      if (popup) {
        popup.setAttribute('aria-hidden', 'true');
      }
    }

    function openCartInfoPopup(trigger) {
      closeCartInfoPopups(trigger);
      trigger.classList.remove('is-magnifier-visible');
      trigger.classList.add('is-info-active');
      setTriggerExpanded(trigger, true);

      const popup = trigger.querySelector('.cart-info-popup');
      if (popup) {
        popup.setAttribute('aria-hidden', 'false');
      }
    }

    function closeSingleCartInfoPopup(trigger) {
      trigger.classList.remove('is-info-active');
      trigger.classList.remove('is-magnifier-visible');
      setTriggerExpanded(trigger, false);

      const popup = trigger.querySelector('.cart-info-popup');
      if (popup) {
        popup.setAttribute('aria-hidden', 'true');
      }
    }

    getPopupTriggers().forEach(function(trigger) {
      if (trigger.dataset.cartInfoReady === 'true') return;
      trigger.dataset.cartInfoReady = 'true';

      const magnifier = trigger.querySelector('.cart-info-magnifier');
      const closeButton = trigger.querySelector('.cart-info-popup-close');
      const popup = trigger.querySelector('.cart-info-popup');
      const directButtons = trigger.querySelectorAll('[data-cart-direct-popup-open]');

      directButtons.forEach(function(button) {
        button.addEventListener('pointerdown', function(e) {
          e.stopPropagation();
        });

        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openCartInfoPopup(trigger);
        });
      });

      if (magnifier) {
        magnifier.addEventListener('pointerdown', function(e) {
          e.stopPropagation();
        });

        magnifier.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openCartInfoPopup(trigger);
        });
      }

      if (closeButton) {
        closeButton.addEventListener('pointerdown', function(e) {
          e.stopPropagation();
        });

        closeButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeSingleCartInfoPopup(trigger);
        });
      }

      if (popup) {
        popup.addEventListener('pointerdown', function(e) {
          e.stopPropagation();
        });

        popup.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }

      trigger.addEventListener('pointerdown', function(e) {
        if (!isCartPopupTapMode()) return;
        if (e.target.closest('[data-cart-direct-popup-open]')) return;
        if (e.target.closest('.cart-info-magnifier')) return;
        if (e.target.closest('.cart-info-popup')) return;
        if (e.target.closest('input')) return;
        if (e.target.closest('a')) return;

        e.stopPropagation();
        showCartMagnifier(trigger);
      });

      trigger.addEventListener('click', function(e) {
        if (!isCartPopupTapMode()) return;
        if (e.target.closest('[data-cart-direct-popup-open]')) return;
        if (e.target.closest('.cart-info-magnifier')) return;
        if (e.target.closest('.cart-info-popup')) return;
        if (e.target.closest('input')) return;
        if (e.target.closest('a')) return;

        e.stopPropagation();
        showCartMagnifier(trigger);
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        if (document.activeElement === trigger) {
          e.preventDefault();
          e.stopPropagation();

          if (trigger.classList.contains('is-info-active')) {
            closeSingleCartInfoPopup(trigger);
          } else if (trigger.classList.contains('is-magnifier-visible')) {
            openCartInfoPopup(trigger);
          } else {
            showCartMagnifier(trigger);
          }
        }
      });

      if (magnifier) {
        magnifier.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            openCartInfoPopup(trigger);
          }
        });
      }

      if (closeButton) {
        closeButton.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            closeSingleCartInfoPopup(trigger);
          }
        });
      }
    });

    if (document.documentElement.dataset.cartFooterGlobalEventsReady !== 'true') {
      document.documentElement.dataset.cartFooterGlobalEventsReady = 'true';

      document.addEventListener('pointerdown', function(e) {
        let clickedInsidePopupArea = false;

        document.querySelectorAll('[data-cart-footer] [data-cart-info-popup]').forEach(function(trigger) {
          if (trigger.contains(e.target)) {
            clickedInsidePopupArea = true;
          }
        });

        if (!clickedInsidePopupArea) {
          document.querySelectorAll('[data-cart-footer] [data-cart-info-popup]').forEach(function(trigger) {
            trigger.classList.remove('is-info-active');
            trigger.classList.remove('is-magnifier-visible');
            setTriggerExpanded(trigger, false);

            const popup = trigger.querySelector('.cart-info-popup');
            if (popup) {
              popup.setAttribute('aria-hidden', 'true');
            }
          });
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('[data-cart-footer] [data-cart-info-popup]').forEach(function(trigger) {
            trigger.classList.remove('is-info-active');
            trigger.classList.remove('is-magnifier-visible');
            setTriggerExpanded(trigger, false);

            const popup = trigger.querySelector('.cart-info-popup');
            if (popup) {
              popup.setAttribute('aria-hidden', 'true');
            }
          });
        }
      });

      window.addEventListener('resize', function() {
        document.querySelectorAll('[data-cart-footer] [data-cart-info-popup]').forEach(function(trigger) {
          trigger.classList.remove('is-info-active');
          trigger.classList.remove('is-magnifier-visible');
          setTriggerExpanded(trigger, false);

          const popup = trigger.querySelector('.cart-info-popup');
          if (popup) {
            popup.setAttribute('aria-hidden', 'true');
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartFooterCustom);
  } else {
    initCartFooterCustom();
  }

  document.addEventListener('shopify:section:load', function() {
    initCartFooterCustom();
  });
})();
